import { ArrowUpRight } from "lucide-react";

import { trackConversion } from "@/lib/tracking-events";

export function FloatingCTA() {
  function scrollToForm(e: React.MouseEvent<HTMLAnchorElement>) {
    if (typeof window === "undefined") return;
    trackConversion("InitiateCheckout", { content_name: "CTA flutuante — Vender imóvel" });
    const el = document.getElementById("vender-imovel");
    if (el) {
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }


  return (
    <a
      href="#vender-imovel"
      onClick={scrollToForm}
      aria-label="Vender imóvel — pedir proposta"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#22c55e] px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-lg shadow-black/20 ring-1 ring-black/5 transition-transform hover:scale-105 hover:bg-[#16a34a] md:bottom-8 md:right-8 md:px-7 md:py-3.5 md:text-base"
    >
      Vender imóvel
      <ArrowUpRight className="h-4 w-4 md:h-5 md:w-5" strokeWidth={2.5} />
    </a>
  );
}
